const conf = {
  // apiUrl: 'http://10.10.16.233:8081/',
  // apiUrl: 'http://10.10.10.54:8081/',
  // apiUrl: 'http://10.10.10.66:8081/',
  // apiUrl: 'http://localhost:8081/',
  // apiUrl: 'http://10.10.15.197:8081/'
  // apiUrl: 'https://loadmax-215011.appspot.com/',
  apiUrl: 'https://loadmax-prod.appspot.com/',
  // apiUrl: 'https://loadmax-dev.appspot.com/',
  // apiUrl: 'https://loadmaxstaging.appspot.com/',
  scriptForMapApi: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDKlPVZZOgME9xC8Ij08EETQoDu26b4mVE&libraries=places",
  setPerPageRecord:10,
  displayDateFormat:"MMM DD, YYYY",
  typeDelivery:"delivery",
  typePickup:"pickup",
  contactEmailAddress:"info@loadmax.com",
  contactNumberMask:"1(###) ###-####",
  contactNumberMaskForInput:"(###) ###-####",
  tooltipTextForUsername:"This LOADMAX Username will be your online profile name for MAXTALKS",
  notProvidedStr:"Not Provided",
  saveFastPostNumberAtATime:20,
  LTLStr:"LTL",
  FULLStr:"FULL",
  ANYStr:"ANY",
  anyStr:"Any",
  anyStrId:"any",
  msgForLeavePage:"Do you really want to leave? You have unsaved changes!",
  errMsgColorStr:"red",
  successMsgColorStr:"green",
  errMsgFormSubmitValidation:"There are some invalid fields in the form. Please check!",
  equipmentTypesDisableDefaultValue:false,
  errMsgForFastPostCheckRecordCount:"At least one entry is required",
  validationMsgForCityCheck:"Invalid Address. Please, select address with City and State",
  validationMsgForOriginDestNotSame:"Origin and Destination address should not be same",
  clientUserAgent:false,
  anywhereStr:"Anywhere",
  noRecordFoundStrForSearch:"Sorry, that filtered search has no results. Please adjust your filters to get more results.",
  invalidLoadIdMsg:"Invalid Load ID or no ID provided",
  mapSearchScrollToOffset:64,
  noRecordFoundStr:"No results found",
  mcNumberLocation:"https://safer.fmcsa.dot.gov/query.asp?searchtype=ANY&query_type=queryCarrierSnapshot&query_param=MC_MX&query_string=",
  descriptionLength:190,
  tripleDots:"...",
  equipmentListLength:20,
  blankStr:"&nbsp;",
  shortFormStr:"short-form",
  longFormStr:"long-form",
  destinationCityNameErrStr:"Destination Address doesn\'t have city name, please select any other address",
  validationMsgForDropOffAndPickupDate:"Dropoff Date should be greater than Pickup Date",
  confirmMsgForDeleteLoad:"Are you sure you want to delete this load?",
  setTimeOutForLoadAndTruckEquipmentType:100,
  setTimeOutForLoadAndTruckDetailMap:100,
  validationMsgForAlphabetNotAllow:"Alphabets not allowed",
  valiationMsgForRate:"Incorrect value. Special charaters(except $ and .) and multiple dots are not allowed",
  cityStr:"city",
  mapStr:"map",
  SeeNotes:"See Notes",
  notMappedStr:"Not Mapped",
  dynamicAggregatorColumnWidth:"20%",
  goToFiltersText:"Click here to update your filters.",
  apiAiAccessToken:"9eccbf1f6fe94b7186baf1eee6b06585",
  apiAiNotUnderstandMsg:"I'm sorry. I could not find an answer to that request",
  apiAiDefaultAuthor:"support",
  apiAiDefaultType:"text",
  profileUrl:"",
  chatBotTitle:"Ask Max",
  chatBotDefaultMsg:"Hi, how can I help you?",
  chatBotPlaceholder:"What do you need…",
  defaultPasswordSymbol:"********",
  forbiddenAccessStatus:403,
  refreshTokenStatus:401,
  logoutMsg:"Login credentials updated successfully, please re-login to continue",
  discourseForumProfileUrl:"https://forum.loadmax.com/",
  defaultProfilePicPath:"/static/profile-img.png",
  updatePhoneSuccessMsg:"Phone Number updated successfully",
  defaultProfilePicWidth:200,
  cancelledMsg:"Don't want to update",
  documentInfoTxt: "This is your personal storage space for your most used business documents. Upload your documents by clicking on the arrow icon and from there you will have the ability to save, share and delete the files. The files that are allowed to be uploaded are JPGs, PNGs, PDFs, GIFs, TXTs, DOCs, CSVs and XML Files. If you have any questions, feel free to call 1.866.925.6608 to speak to a support representative",
  needToUploadTxt: "Need To Upload",
  clickToShareTxt: " Click to Share",
  sessionTimeForRefreshToken:120,
  // storageBucketUrl:"https://loadmax-dev-bucket.storage.googleapis.com/",
  storageBucketUrl:"https://storage.googleapis.com/loadmax-prod-bucket/",
  dashboardDefaultValue:0,
  documentDownloadSuccessMsg:'Document downloaded successfully',
  confirmPinNoValidationMsg:'Pin and confirm pin do not match.',
  pinGenerateSuccessMsg:'Pin generated successfully.',
  imrReferralUrl:"https://www.loadmax.com/signup?",
  thankYouPageUrl:"https://www.loadmax.com/download-successfully",
  maxAvatarInfoTxt: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  maxAvatarFileSizeValidationMsg: "File should be less than 2MB",
  maxAvatarFileTypeValidationMsg: "You can only upload PNG or JPG",
  chatbotAvatrsStorageFolderName: "chatbot-avatars",
  tryAgainLetterMSG: "Error!!! Something went wrong.",
  alertMsgForForgotPassword: "A link to reset password has been successfully sent to your registered Email.",
  defaultEmailAddress: "support@LOADMAX.com",
  defaultContactNumber: "1.866.925.6608",
  defaultAddress: "5930A Harbour Park Drive Midlothian, VA 23112",
  changePlanInfoTxt: "If you would like to change your LOADMAX Subscription, please contact a LOADMAX support representative via phone or email.",
  imrUserStr: "imr",
  errAutoloader: "Please select a file to upload.",
  passwordEncryptionStatus:440,
  passwordEncryptionMsg:"Session timeout. Please relogin.",
  incorrectFileFormat:'Incorrect File Format!',
  secretKeyForIncryption:'ABCDEFG!@#$%^&*()_+HIJKLMNOPQRSTUVabcdefghijklmnovwxyz01456789',
  downloadDocPublicUrl:'https://dashboard.loadmax.com/documents/download-document?',
  maxTalkClickedMsg:"Welcome to MAXTALKS. Since this is your first time checking out the community, learn more in the MAXTALK categories from the latest news and also to introduce yourself. MAXTALKS will open in a new browser window, but your LOADMAX login works for both LOADMAX and MAXTALKS. Talk to you soon!",
  userRolesBrokerDefaultSlug:"broker",
  userRolesTruckerDefaultSlug:"trucker"
};
if(process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'development'){
  conf.apiUrl = "https://loadmax-dev-a3-dot-loadmax-dev.appspot.com/";
  conf.storageBucketUrl = "https://loadmax-dev-bucket.storage.googleapis.com/";
  conf.scriptForMapApi = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAEwiltuPVylK1IZWraB2JAKzkOxc8-CM4&libraries=places";
  conf.imrReferralUrl = "http://103.231.222.49/loadmax-marketing/signup?";
  conf.downloadDocPublicUrl = "https://loadmax-dev.firebaseapp.com/documents/download-document?";
}
module.exports = conf;



// WEBPACK FOOTER //
// ./src/config.js